import { PageKey } from '@core/enums/page-keys.enum';
import { FlowId, type CheckinWorkflow } from '../workflow-engine.types';

export enum PrintBadgeStep {
  Start = 'Start',
  Options = 'Options',
  Print = 'Print',
  Success = 'Success',
  FailEmail = 'FailEmail',
  Fail = 'Fail',
}

export const printBadgeFlow: CheckinWorkflow<PrintBadgeStep> = {
  id: FlowId.PrintBadge,
  entry: PrintBadgeStep.Start,
  steps: {
    [PrintBadgeStep.Start]: {
      id: PrintBadgeStep.Start,
      next: (variables) =>
        variables.isEmailProvided && !variables.checkinProcessConfiguration?.hasPrintMandatory
          ? { nextStep: PrintBadgeStep.Options }
          : { nextStep: PrintBadgeStep.Print },
    },
    [PrintBadgeStep.Options]: {
      id: PrintBadgeStep.Options,
      page: PageKey.PRINT_BADGE_OPTIONS,
      next: (variables) =>
        variables.skipPrintBadge === false
          ? { nextStep: PrintBadgeStep.Print }
          : { complete: true },
    },
    [PrintBadgeStep.Print]: {
      id: PrintBadgeStep.Print,
      page: PageKey.PRINT_BADGE,
      next: (variables) => {
        if (variables.isPrintBadgeSuccess) {
          return { nextStep: PrintBadgeStep.Success };
        }
        return variables.isEmailProvided
          ? { nextStep: PrintBadgeStep.FailEmail }
          : { nextStep: PrintBadgeStep.Fail };
      },
    },
    [PrintBadgeStep.Success]: {
      id: PrintBadgeStep.Success,
      page: PageKey.PRINT_BADGE_SUCCESS,
      next: () => ({ complete: true }),
    },
    [PrintBadgeStep.FailEmail]: {
      id: PrintBadgeStep.FailEmail,
      page: PageKey.PRINT_BADGE_FAIL_EMAIL,
      next: () => ({ complete: true }),
    },
    [PrintBadgeStep.Fail]: {
      id: PrintBadgeStep.Fail,
      page: PageKey.PRINT_BADGE_FAIL,
      next: () => ({ bubble: 'exit' }),
    },
  },
};
